import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Container,
  Box,
} from "@mui/material";
import { useNavigate } from "react-router";

import signup_bg from "../../assets/img/login_bg.jpg";
import logo from "../../assets/img/logo.svg";
import { Link } from "react-router-dom";
import { showToast } from "../../util/toastHelper";
import { ToastContainer, toast } from "react-toastify";
import Loading from "react-fullscreen-loading";
import { CallWithOutAuth } from "../../action/apiActions";
import { FORGET_PASSWOED } from "../../action/apiPath";
import { errorMessageCreate } from "../../util/custom";

export const ForgetPassword = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = React.useState(false);
  const [expanded, setExpanded] = React.useState(false);
  const [authDetail, setAuthDetail] = React.useState({
    email: null,
  });
  const [emailError, setEmailError] = React.useState(null);

  const handleChange = (panelIndex) => (event, isExpanded) => {
    setExpanded(isExpanded ? panelIndex : false);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setEmailError("");
    let isValid = true;
    if (!authDetail.email) {
      setEmailError("* Email is required.");
      isValid = false;
      //   return;
    } else if (!emailRegex.test(authDetail.email)) {
      setEmailError("* Invalid email format.");
      //   return;
      isValid = false;
    }

    if (isValid) {
      setIsLoading(true);

      try {
        const res = await CallWithOutAuth("POST", FORGET_PASSWOED, {
          email: authDetail.email,
        });
        // console.log(res);
        if (res?.res?.data?.statusCode === 201||res?.res?.data?.statusCode === 200) {      
          showToast("success", errorMessageCreate(res?.res?.data?.message));
          authDetail.email = "";

        } else {
          showToast("error", errorMessageCreate(res?.res?.data?.message));

        }
      } catch (error) {
        console.log(error);
      }
      setIsLoading(false);

      // navigate()
    }
    // navigate("/reset-password");

    // If validation passes, proceed with form submission
  };
  const handleEmail = (e) => {
    setAuthDetail((prevState) => ({
      ...prevState, // Spread the previous state to keep the password
      email: e.target.value, // Update the email
    }));
  };
  return (
    <>
      {isLoading && (
        <Loading
          loading
          background="rgba(236, 240, 241, 0.7)"
          loaderColor="#3498db"
        />
      )}

      <section class="login_signup_wrapper">
        <div class="img_colm">
          <div class="back_btn" onClick={() => navigate("/")}>
            <i class="fa-solid fa-chevron-left"></i>
          </div>
          <div class="img_block">
            <img src={signup_bg} alt="" />
          </div>
        </div>
        <div class="form_colm">
          <div class="inner_block">
            <img src={logo} alt="" class="logo_img" />
            <h1>Forget Password</h1>
            <p>We'll send you a link to reset your password.</p>

            <form onSubmit={handleSubmit} class="form_block">
              <div class="form_field">
                <div class="input_grp">
                  <label for="">Email</label>
                  <input
                    type="text"
                    onChange={handleEmail}
                    value={authDetail.email}
                  />
                </div>
                <span className="red_error">{emailError}</span>
              </div>

              <>
                <div class="btn_block">
                  <button type="submit">Forget password</button>
                </div>
              </>

              <p>
                Do you have account continue login?{" "}
                <Link to={"/login"}> &nbsp; Login</Link>
              </p>
            </form>
          </div>
        </div>
      </section>
      <ToastContainer></ToastContainer>
    </>
  );
};

export default ForgetPassword;
